<template>
  <button
    @click="onClick()"
    :class="[
      'flex items-center justify-center font-semibold',
      buttonClass,
      isLoading ? '!cursor-not-allowed' : '',
    ]"
    :disabled="isLoading"
  >
    <svg
      v-if="isLoading"
      class="animate-spin h-5 w-5 mr-3 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 0 1 16 0H4z"
      ></path>
    </svg>
    <span v-if="!isLoading"
      >{{ text }}
      <slot name="nonLoadingText"></slot>
    </span>
    <span v-if="isLoading">{{ loadingText }}</span>
  </button>
</template>

<script setup lang="ts">
interface Props {
  text?: string;
  loadingText?: string;
  isLoading?: boolean;
  buttonClass?: string | string[];
}

const props = withDefaults(defineProps<Props>(), {
  text: "Submit",
  loadingText: "loading...",
  isLoading: false,
  buttonClass: "primary-btn",
});

const emit = defineEmits<{
  (e: "click"): void;
}>();

const onClick = () => {
  emit("click");
};
</script>
